import React, { useMemo } from 'react';
import { Container } from 'react-bootstrap';
import CountryCarousel from '../components/International/CountryCarousel';
import { RECOMMENDED_ARTICLES_TITLE } from '../components/International/consts';
import { articlesCardData } from '../content/articles/ArticlesCardData';
import ArticleCardsContainer from '../components/Article/ArticleCardContainer';

const getRandomArticles = (
  articles: typeof articlesCardData,
  count: number
) => {
  const allArticles = Object.entries(articles).flatMap(
    ([country, countryArticles]) =>
      countryArticles.map((article) => ({
        ...article,
        countrySlug: country,
      }))
  );

  const shuffled = [...allArticles].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const International = () => {
  const randomArticles = useMemo(
    () => getRandomArticles(articlesCardData, 6),
    []
  );

  return (
    <Container>
      {/* <PageTitle>{INTERNATIONAL_TITLE}</PageTitle> */}
      <CountryCarousel />
      <ArticleCardsContainer
        title={RECOMMENDED_ARTICLES_TITLE}
        articles={randomArticles}
      />
    </Container>
  );
};

export default International;
